// https://github.com/MaxQNEI/LibraryJS/blob/90c20189889cc605755930cec0c3ad199dfe11f3/string.mtdname.js
export default function MtdName(string) {
    string = string.split(/[^A-Za-z0-9]+/i);
    string.map((v, i) => {
        string[i] = `${v.substr(0, 1).toUpperCase()}${v.substr(1).toLowerCase()}`;
    });
    return string.join("");
}
